import { render } from "./freshAirFan.vue?vue&type=template&id=a90f5d68&scoped=true"
import script from "./freshAirFan.vue?vue&type=script&lang=js"
export * from "./freshAirFan.vue?vue&type=script&lang=js"

import "./freshAirFan.vue?vue&type=style&index=0&id=a90f5d68&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90f5d68"]])

export default __exports__